<template>
  <main class="app">
      <nav-popout 
        :navState="toggledNavState"
      />
      <loader :isLoading="isLoading"></loader>
      <CookieBanner :cookieBannerShown="cookieBannerShown" />
      <transition-page>
        <router-view></router-view>
      </transition-page>
  </main>
</template>

<script>
import Loader from '@/components/Loader.vue';
import TransitionPage from '@/components/transitions/TransitionPage.vue';
import NavPopout from "@/components/Nav.vue";
import CookieBanner from '../components/CookieBanner.vue';

export default {
  components: { Loader, TransitionPage, NavPopout, CookieBanner },
  data() {
    return {
      isLoading: true,
      cookieBannerShown: false,
    };
  },
  mounted() {
    this.calcHeight();
    if (!window.localStorage.getItem('selectedLangShort')) {
      window.localStorage.setItem('selectedLangShort', 'en');
    }

    if(window.localStorage.getItem('cookieBannerShown') !== null){
      this.cookieBannerShown = window.localStorage.getItem('cookieBannerShown');
    }

  },
  computed: {
    toggledNavState() {
      return this.$store.state.sidebarStatus;
    }
    // toggledSearchState() {
    //   return this.$store.state.searchStatus;
    // },
  },
  methods: {
    calcHeight() {
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }
};
</script>